import React, { useCallback, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { Spinner } from "@material-tailwind/react";
import { httpPostProcessing } from "../../../services/http-common";
import { setSessionExpired, useMainController } from "../../../context";
import { toast } from "react-toastify";

const DocsStatus = ({ docType }) => {
  const [dispatch] = useMainController();
  const [docStatistics, setDocStatistics] = useState(null);

  const getPrompt = useMutation(
    () => {
      return httpPostProcessing.post(
        "train/book/get-mine-docs-statistics",
        {},
        setSessionExpired,
        dispatch
      );
    },
    {
      onSuccess: ({ data }) => {
        setDocStatistics(data.statistics);
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );

  const getStatistics = useCallback(() => {
    getPrompt.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getStatistics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div className="bg-white shadow-md rounded-lg p-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
          <div className="flex flex-col justify-center items-center">
            {docStatistics ? (
              <h5 className="!text-sm sm:!text-base font-semibold">
                {docStatistics?.total}
              </h5>
            ) : (
              <Spinner color="blue" className="self-center" />
            )}
            <p className="text-gray-500 text-xs sm:!text-sm sm:!text-base">
              Total Documents
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            {docStatistics ? (
              <h5 className="text-lg sm:text-xl font-semibold">
                {docStatistics?.accepted}
              </h5>
            ) : (
              <Spinner color="blue" />
            )}
            <p className="text-gray-500 text-xs sm:!text-sm sm:!text-base">
              Approved
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            {docStatistics ? (
              <h5 className="text-lg sm:text-xl font-semibold">
                {docStatistics?.pending}
              </h5>
            ) : (
              <Spinner color="blue" />
            )}
            <p className="text-gray-500 text-xs sm:!text-sm sm:!text-base">
              Pending
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            {docStatistics ? (
              <h5 className="text-lg sm:text-xl font-semibold">
                {docStatistics?.rejected}
              </h5>
            ) : (
              <Spinner color="blue" />
            )}
            <p className="text-gray-500 text-xs sm:!text-sm sm:!text-base">
              Rejected
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DocsStatus;
